import { Avatar as AntdAvatar } from "@empglabs/backoffice-ui-kit"

const Avatar = props => {
  return <AntdAvatar {...props} />
}
export default Avatar
